import { IOfferAction } from '@models/winnerSelection/ITableDemand';
import { FilesService } from '@services/FilesService';

export const offerAttachmentsUrl = (offerKey: string, tableKey: string, actionKey: string) =>
    `winnerSelection/downloadAttachments/${offerKey}/${tableKey}/${actionKey}`;

/**
 * «Скачать документацию» предложения: с `runInBackground` у действия — окном сборки архива (`onArchive`), без
 * него — файл сразу.
 */
export const downloadOfferAttachments = (
    offerKey: string,
    tableKey: string,
    action: IOfferAction,
    onArchive: () => void,
): void => {
    if (action.runInBackground) onArchive();
    else FilesService.downloadFileNative(offerAttachmentsUrl(offerKey, tableKey, action.key));
};
